export function NotFoundPage() {
  return (
    <section class="empty-state">
      <h2>Page not found</h2>
      <p>Check the payment link and try again.</p>
    </section>
  );
}
